/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import Header from "./Header/Header";
import NewHeader from "./Header/newHeader";
import { Container } from "reactstrap";
import SideMenu from "./SideMenu/SideMenu";
import { useAtom } from "jotai";
import { auth_token } from "../../AtomStore/store";
import { useLocation, useNavigate } from "react-router-dom";
import BottomPanel from "./BottomPanel/BottomPanel";
import NotificationService from "../../Components/utils/NotificationService";

const LoggedInLayout = (props) => {
  const [token] = useAtom(auth_token);
  const location = useLocation();

  const navigate = useNavigate();
  useEffect(() => {
    if (token === "") {
      navigate("/login");
    }
  }, []);

  const isWhiteBg = location.pathname === "/blogs";

  return (
    <React.Fragment>
      <NotificationService />

      <NewHeader />

      <div
        className={`flex flex-col h-dvh overflow-hidden ${
          isWhiteBg ? "" : "bg-[#eaf3fa]"
        }`}
      >
        <SideMenu />

        <div
          id="scrollable_container"
          className={`flex-grow h-dvh overflow-y-auto ${
            isWhiteBg ? "" : "bg-[#eaf3fa]"
          }  main-content [@media(max-height:580px)]:pb-[50px]`}
        >
          <Container fluid={true}>{props.children}</Container>
        </div>

        <BottomPanel />
      </div>
    </React.Fragment>
  );
};

export default LoggedInLayout;
